import type { ReactNode } from 'react';

import { createKeyboardClickHandler } from '@/utils/accessibility';

import { GiveAsAGift } from '@/messages/common';

import * as S from './Button4Gift.styles';

interface Button4GiftProps {
  /**
   * BEC-24926: the PDP swapped this grey button over to Call to buy, so the
   * label is now passed in. Defaults to the 4Gift copy for existing callers.
   */
  children?: ReactNode;
  onClick: () => void;
}

export const Button4Gift = ({
  children = GiveAsAGift,
  onClick,
}: Button4GiftProps) => {
  return (
    // BEC-24926: this renders a div, so it needs the button role, a tab stop
    // and a key handler to be reachable without a mouse. It carries a purchase
    // action - Call to buy on the mobile PDP - so it cannot be click-only.
    <S.BtnContainer
      onClick={onClick}
      onKeyDown={createKeyboardClickHandler(onClick)}
      role='button'
      tabIndex={0}
    >
      <S.GiftBtnContainer>{children}</S.GiftBtnContainer>
    </S.BtnContainer>
  );
};
